'use strict';

function _FormWizard() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;

  this._baseClassName = 'form-wizard__section';
  this.states = {
    passive: this._baseClassName + '--passive',
    edit: this._baseClassName + '--edit',
    change: this._baseClassName + '--change',
    summary: this._baseClassName + '--summary'
  };

  this._changeState = function (element, newState) {
    if (typeof element === 'undefined') {
      return;
    }
    element.data('form-wizard-state', newState);
    var stateRegExp = new RegExp(this._baseClassName + '--\\w*');
    var elementState = element.attr('class').match(stateRegExp); // find the matching element state
    if (!elementState || !elementState.length) {
      // no existing element state
      element.addClass(newState);
    } else if (elementState[0] != newState) {
      element.switchClass(elementState[0], newState);
    }
  };

  this._getState = function (element) {
    var result = false;
    $.each(this.states, function (key, val) {
      if (element.data('form-wizard-state') == val) result = val;
    });
    return result;
  };

  this.init = function () {};
  this.initAllReady = function () {};
}